export default "__VITE_ASSET__Te9zD5mm__"